import { render, staticRenderFns } from "./settings-organization-domains.vue?vue&type=template&id=1766130a&scoped=true&"
import script from "./settings-organization-domains.vue?vue&type=script&lang=js&"
export * from "./settings-organization-domains.vue?vue&type=script&lang=js&"
import style0 from "./settings-organization-domains.vue?vue&type=style&index=0&id=1766130a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1766130a",
  null
  
)

export default component.exports